import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import classnames from 'classnames/bind';
import * as graph from '@adc/sdk';
import * as blueprint from '@adc/blueprint';
import styles from './styles.scss';
import Term from '../term';
import Text from '../../elementals/text';
import ExpandableCard from '../../layouts/expandableCard';
import CardContainer from '../cardContainer';
import { GRAPH_API_FRAGMENT_DEFINITION, GRAPH_API_FRAGMENT_REFERENCE, } from '../../../utils/symbols';
const HEADER_HEIGHT = 24 + 18 * 2 + 18;
const TERM_HEIGHT = 70;
const cx = classnames.bind(styles);
const TermsCard = ({ title = 'Seller Terms', className, initialActiveState = false, listing, viewingFrom = graph.enums.CurrentTargetAudience.Seller, elmId = 'expandable-terms-card', }) => {
    const terms = useMemo(() => {
        const badges = blueprint.listing.utils.calculatePrivateSellerBadges(listing, viewingFrom);
        return badges
            .filter(badge => badge.title != 'Rentback' ||
            (badge.title === 'Rentback' && badge.content != 'None'))
            .map((badge) => ({
            iconName: badge.titleIcon,
            label: badge.title,
            value: badge.content,
            isMoneyValue: Boolean(badge.moneyValue) ?? false,
            tooltipContent: badge.tooltipContent,
            elmId: `${elmId}-${badge.title
                .toLowerCase()
                .replace(/\s+/g, '-')}-term`,
        }));
    }, [listing, viewingFrom]);
    const [active, setActive] = useState(initialActiveState);
    const slots = {
        card: ({ elmId, children, className, } = {}) => (_jsx(CardContainer, { elmId: elmId, className: className, borderRadius: 'medium', padding: 'small', children: children })),
        header: () => (_jsx("div", { "data-elm-id": `${elmId}-header`, style: { width: '100%' }, children: _jsx(Text.Body, { size: 'large', weight: 'heavy', children: title }) })),
        content: () => (_jsx("div", { "data-elm-id": `${elmId}-terms`, className: cx('terms'), children: terms.map((term, index) => (_jsxs(_Fragment, { children: [_jsx(Term, { ...term }, index), index < terms.length - 1 && _jsx("div", { className: cx('divider') })] }))) })),
    };
    return (_jsx(ExpandableCard, { slots: slots, active: active, onClick: () => setActive(!active), classNames: { card: cx('terms-card', className) }, heightHints: {
            collapsed: HEADER_HEIGHT,
            expanded: terms.length * TERM_HEIGHT + HEADER_HEIGHT,
        } }));
};
TermsCard[GRAPH_API_FRAGMENT_DEFINITION] = `
  fragment TermsCardFields on Listing {
    seller_terms {
      finance_terms {
        finance_preference
        is_contingency
      }
      inspection_terms {
        is_contingency
        is_option_contingency
      }
      leaseback_terms {
        leaseback_period_in_days
      }
    }
    listing_configuration {
      are_private_tours_available
      days_to_close
    }
    program_configuration {
      earnest_money_deposit_minimum_amount
    }
  }
`;
TermsCard[GRAPH_API_FRAGMENT_REFERENCE] = '...TermsCardFields';
export default TermsCard;
//# sourceMappingURL=index.js.map